// extracted by mini-css-extract-plugin
module.exports = {"errorConnecting":"CheckoutPage_errorConnecting__21NQ2"};